module.exports = __webpack_public_path__ + "static/media/wins-spectre-center.2a1a17d0.png";